export default {
    data: () => ({
        
    }),
    computed: {
        img_url() {
            return this.$store.state.img_domain;
        },
    }
}